import { render, staticRenderFns } from "./KripTable.vue?vue&type=template&id=79766dc6&"
import script from "./KripTable.vue?vue&type=script&lang=js&"
export * from "./KripTable.vue?vue&type=script&lang=js&"
import style0 from "./KripTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports